export enum LadingType {
    Normal = 1,
    Forward = 2,
    Retransport = 3
}